const QuoteTypesEnum = {
  Service: {
    id: 1,
    name: "Service Call",
  },
  Installation: {
    id: 2,
    name: "New Installation",
  },
  PreventiveMaintenance: {
    id: 3,
    name: "Preventive Maintenance",
  },
  Warranty: {
    id: 4,
    name: "Warranty",
  },
};

export default QuoteTypesEnum;
